import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {
    switchOutput,
    execute,
    notes,
    steps,
    prob,
} from './lang.js';
import {beat} from './beat.js';

class BeatEffect extends ScriptingEffect {
    constructor(track) {
        super("Beat", track);
        this.newVar('step', 0, 0, 32);
        this.newVar('steps', 16, 0, 64);
        this.numberOfOutputs = 2;
        this.clear();
    }

    get documentation() {
        return [
            "Sends triggers to output 1 on a specific step of the beat.",
            "All other triggers go to output 2."
        ];
    }

    getVisualizedParameters() {
        return [this.stepParameter, this.stepsParameter];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            beat(
                this.var('step'),
                this.var('steps'),
                switchOutput(0),
                switchOutput(1)));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new BeatEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default BeatEffect;
